import { useState, useEffect, useCallback } from "react";
import { apiFetch } from "../../../context/AuthContext";
import { BASE_URL } from "../utils/reportsHelpers";

const useScheduledReports = (currentUser) => {
  const [schedules, setSchedules] = useState([]);
  const [schedulesLoading, setSchedulesLoading] = useState(true);

  const fetchSchedules = useCallback(async () => {
    if (!currentUser) return;
    setSchedulesLoading(true);
    try {
      const res = await apiFetch(`${BASE_URL}/reports/schedules?infinityCode=${currentUser}`, { method: "GET" });
      const data = await res.json();
      setSchedules(data.schedules || []);
    } catch {
      // non-critical — fail quiet
    } finally {
      setSchedulesLoading(false);
    }
  }, [currentUser]);

  useEffect(() => { fetchSchedules(); }, [fetchSchedules]);

  const createSchedule = useCallback(async (payload) => {
    const res = await apiFetch(`${BASE_URL}/reports/schedules`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ infinityCode: currentUser, ...payload }),
    });
    if (!res.ok) throw new Error((await res.json().catch(() => ({}))).error || "Failed to schedule report");
    await fetchSchedules();
    return res.json();
  }, [currentUser, fetchSchedules]);

  const deleteSchedule = useCallback(async (id) => {
    setSchedules((prev) => prev.filter((s) => s.id !== id));
    await apiFetch(`${BASE_URL}/reports/schedules/${id}`, { method: "DELETE" }).catch(() => null);
  }, []);

  const toggleSchedule = useCallback(async (id, isActive) => {
    setSchedules((prev) => prev.map((s) => (s.id === id ? { ...s, isActive } : s)));
    await apiFetch(`${BASE_URL}/reports/schedules/${id}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ isActive }),
    }).catch(() => null);
  }, []);

  return { schedules, schedulesLoading, createSchedule, deleteSchedule, toggleSchedule, refetchSchedules: fetchSchedules };
};

export default useScheduledReports;
